export const STAR_SPARKLE_SVG = '/svg/star-sparkle.svg';

export const CUSTOMER_CHAT_LULA = '/svg/customer-chat-lula-logo.svg';
export const MESSAGE_BOT_ICON = '/svg/BotIcon.svg';
export const X_CLOSE = '/svg/XCloseIcon.svg';
export const PM_NO_MESSAGE_SVG = '/svg/pm-no-message.svg';
export const NO_DATA_SVG = '/svg/no-data.svg';
export const LOADER_SVG = '/svg/loader.svg';
